
import Modalv2 from './Modalv2.vue';
import { canCreatePortfolio } from '~/utils/behavior/portfolio-creation';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NoEligiblePortfolioModal',
  components: {
    Modalv2,
  },
  props: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters('portfolio', ['myOwnedPortfolios', 'getMyPortfoliosRes']),
    ...mapGetters('authentication', [
      'isEmailConfirmed',
      'isVerifiedInfluencer',
    ]),
    canCreatePortfolio() {
      return canCreatePortfolio(
        this.isEmailConfirmed,
        this.myOwnedPortfolios.length,
        this.isVerifiedInfluencer
      );
    },
    portfolios() {
      return this.getMyPortfoliosRes?.data?.portfolios;
    },
    modalTitle() {
      return this.getMyPortfoliosRes?.data?.portfolios?.length > 0
        ? this.$t('no_eligible_portfolio')
        : this.$t('no_portfolio');
    },
  },
  methods: {
    ...mapActions('modals', ['toggleNoEligiblePortfolioModal']),
    handleCloseModal() {
      this.toggleNoEligiblePortfolioModal(false);
    },
    handleButtonClick() {
      this.$emit('onCreatePortfolio');
      this.handleCloseModal();
    },
  },
};
